export const contest = {
  qjy: 'Trading',
  grbm: 'Individual Registration',
  qdl: 'Login',
  bsyjs: 'The game is over',
  bsjs: 'Competition is over',
  djs: 'COUNTDOWN',
  days: 'D ',
  hours: 'H ',
  minutes: 'M ',
  seconds: 'S',
  ljyq: 'Invite now',
  tdbm: 'Team Registration',
  qzc: 'Sign up',
  qrsfgrbm: 'Confirm whether to participate in individual registration?',
  qxbm: 'Cancel',
  qrbm: 'Confirm',
  gxnbmcg: 'Congratulations, your registration is successful and you will receive 10W USDT simulated funds',
  xzjs: 'Choose the character you want to be',
  cwty: 'Be member',
  cwtz: 'Be leader',
  cjtd: 'Create a team',
  jtgz: 'Group building rules: ',
  jtgz1: '1.Groups with less than 5 members within 24 hours after formation will be automatically disbanded and automatically registered for the simulated individual competition',
  jtgz2: '2.You cannot register to participate in the simulated individual competition while waiting to form a group.',
  jtgz3: '3.After forming a team, you will not be able to join other teams or simulate individual matches',
  tdmc: 'Team name:',
  tdjj: 'Team profile: ',
  ljjt: 'Create',
  tdmcbt: 'Please enter team name',
  tdjzbt: 'Please enter team profile',
  cjzdcg: 'Team created successfully!',
  xzjrtd: 'Choose the team you want to join',
  sstdmc: 'Search team name',
  dqzdsl: 'Current number of teams: {v1}, choose the team you want to join',
  ddtdrs: 'Current team size: {v1} people',
  tdrs: 'Team size: ',
  tzmc: 'Team leader name: ',
  jrtd: 'Join',
  jrzdcg: 'Joined the team successfully!',
  grfxlj: 'Person share link: ',
  grtjm: 'Share code: ',
  tdfxlj: 'Team share link: ',
  tdtjm: 'Share code: ',
  tdtzm: 'Team captain name: ',
  bctp: 'Save',
  total: 'Total {v1} items',
  dd: 'to',
  qd: 'Sure',
  cyyj: 'Reward upon participation',
  jcdnn: 'USDT prize pool is waiting for you',
  jzcj: 'Donate profits and participate in the lottery',
  dqjc: 'Current prize pool: ',
  qjz: 'Go donate',
  jzsm: 'Donation instructions',
  kjz: 'You can currently donate to the {v1} USDT Charity Fund. Are you sure you want to donate?',
  qxjz: 'Cancel donation',
  qrjz: 'Confirm donation',
  jzcg: 'Congratulations, your donation was successful!',
  mnpjyds: 'Simulated Trading Competition',
  bm: 'Sign up: ',
  bs: 'Contest: ',
  hyspjyds: 'Futures Trading Competition ',
  xhspjyds: 'Spot Trading Competition',
  bmz: 'Registration in progress',
  jqqd: 'Stay tuned',
  bsz: 'In the game',
  yjs: 'Over',
  myptts: 'Simulated Team Competition ',
  mypzmxs: 'Weekly Star List',
  mypgrs: 'Simulated Individual Competition',
  hyjyds: 'Futures Trading Competition ',
  xhjyds: 'Spot Trading Competition',
  my: 'My',
  pm: 'Ranking',
  dync: 'Nickname',
  dm: 'Name',
  zdrs: 'Members',
  nc: 'Nick name',
  ljzjy: 'Total transactions',
  ljzjye: 'Total transaction volume',
  ljzyll: 'Total profit rate',
  zyll: 'Total profitability',
  zdjl: 'Team rewards',
  mypbsjl: 'Participation Rewards',
  myphycs: 'Participate in the Simulated Futures Competition',
  myhyj: 'Successful registration grants 100,000U in simulated futures',
  ljbm: 'Click to participate',
  tzjl: 'Team Opening Award',
  ztcg: 'Form a team ≥ 5 member( Max 200 )',
  bwzbhl: 'Successful team leaders can receive 100,000U++',
  yqjl: 'Invitation Reward',
  yqhycybs: "Team leader's invitation, up to 100,000U",
  hzhyj: "Member's invitation, up to 50,000U",
  mnttbssm: 'Simulation Team Competition Rules',
  // 团队赛规则
  csxq: 'Competition details: ',
  csxq1: '1、During the event registration period to the end of the competition, users with KYC approval can freely form teams. The futures team race must have a team size of ≥ 5 people; ≤ 200 people. If a team is not filled within 24 hours after formation, the team will be automatically disbanded, and team members will be automatically added to the individual competition.',
  csxq2: '2、Users can only choose 1 team to join and cannot participate in team competitions and individual competitions simultaneously. Once users join a team, they cannot voluntarily exit the team.',
  ssgz: 'Event rules: ',
  ssgz1: "Captain's Benefits: 1) For each invited team member, the captain can receive 1,000 USDT in simulated futures， with an invitation reward cap of 100,000 USDT.",
  ssgz1_2: ' 2) Captains who successfully invite more than 20 friends to join and trade can receive exquisite BiKing merchandise.',
  ssgz2: '2、Team Member Benefits: Team members can receive 500 USDT in simulated futures Bonus for each friend they invite to join, with an invitation reward cap of 50,000 USDT.',
  ssgz3: '3、 After the team competition concludes, the platform will use the actual total transaction volume of the team as the criteria for determining the final overall ranking',
  ssgz4: '4、The total transaction volume in the simulated trading team competition area will be updated daily at 12:00 AM',
  ssgz5: '5、In order to ensure the fairness of the competition results, please refrain from engaging in maliciously inflating transaction numbers. If any such behavior is detected, the Biking customer service team will intervene',
  ssgz6: '6、For a detailed understanding of the activity rules, please contact the Biking customer service team',
  jlfp: 'Reward Allocation: ',
  jlfp1: '1、USDT Bonus Distribution: (When distributing bonuses, the bonus USDT and cash are always allocated in a 9:1 ratio)',
  jlfp1_1: '1）Internal Team Allocation Ratio:',
  jlfp1_2: "Team Leader's Bonus = Team Leader's Personal Cumulative Contract Trading Volume / Total Trading Volume of Biking Simulated Team Race * 5,000,000 USDT",
  jlfp1_3: 'Sum of Performance of Other Team Members within the Team / Total Trading Volume of Biking Simulated Team Race * 20% * 5,000,000 USDT.',
  jlfp1_4: "Team Members' Bonus = Current Cumulative Contract Trading Volume of the User / Total Trading Volume of Biking Simulated Team Race * 80% * 5,000,000 USDT",
  jlfp1_5: '2）Outstanding performing teams during the competition period can enjoy collective profit bonuses! The bonus percentage is determined based on the team size and total trading volume. For every doubling of team size / total trading volume, a 50% computing power bonus can be enjoyed!',
  myptdjyze: 'Total transaction volume of simulation competition team division',
  myptdphb: 'Simulation Competition Team Ranking',
  tdsl: 'Current number of teams: {v1}，choose the team you want to join',
  tznc: 'Leader nickname: ',
  tdjs: 'Team introduction: ',
  // 周明星规则
  mypzmxgzsm: 'Simulation Weekly Star Competition Rules',
  zmxphb: 'Weekly star team rankings (top three)',
  zmxtdphb: 'Weekly star team rankings',
  bdxq: 'Leaderboard Details:',
  bdxq1: '1、Successfully forming a team and starting trading automatically qualifies you for the Weekly Star Team Leaderboard ranking.',
  zmxgz: "1、The system will consider each natural week as one cycle and rank the currently participating teams in the Weekly Star Team Leaderboard based on the team's total trading volume. The top 3 teams on the leaderboard will share a reward of 2,000,000 USDT in Futures Simulated Bonus.",
  zmxgz1: '2、The Weekly Star Team Leaderboard is updated every Wednesday at 14:00',
  bddym: 'The 1st place on the leaderboard receives 1,000,000 USDT in simulated futures.',
  dbdem: 'The 2nd place receives 600,000 USDT in simulated futures.',
  bddsm: 'The 3rd place receives 400,000 USDT in simulated futures.',
  tdnbfpgz: 'Internal Team Distribution Rules: ',
  tzx: 'Team Leader: 20%；',
  nbyjpm: 'Top ten team members in the internal performance ranking（excluding the leader）: Share 40%',
  syty: 'Remaining team members: 40%',
  // 个人赛规则
  mypgrsgzsm: 'Simulated Individual Competition Description',
  mypgrphb: 'Simulated Individual Competition Leaderboard',
  bsxz: 'Participation Guidelines: ',
  bsxz1: '1、Each new user who signs up for the competition will receive 100,000 USDT in simulated futures',
  bsxz2: '2、Existing users who sign up for the competition will receive 50,000 USDT in simulated futures.',
  bsxz3: '2、During the competition, users can continue to earn Bonus by inviting friends to participate as follows: ',
  bsxz4: '1）For each user invited to join the competition, you can receive 2,000 USDT in simulated futures Bonus',
  // bsxz5: '2）For each user invited to join the competition, you can receive 2,000 USDT in simulated futures Bonus',
  bsxz6: '2）The maximum cumulative invitation reward is capped at 50,000 USDT',
  bsxz7: '3、This competition zone is open only to verified users on BiKing Exchange',
  bsxz8: '4、After the competition ends, the final total trading volume of participating users will be used as the criterion for ranking in the individual competition zone',
  grgzsm1: '1、Total Prize Pool: 2,000,000 USDT + 30 exquisite peripherals',
  grgzsm2: '2、Allocation Details: ',
  grgzsm3: '1st Place: 800,000 USDT + 5 exquisite peripherals',
  grgzsm4: '2nd Place: 500,000 USDT + 5 exquisite peripherals',
  grgzsm5: '3rd Place: 200,000 USDT + 3 exquisite peripherals',
  grgzsm6: '4th-20th Place: Share 500,000 USDT + 17 exquisite peripherals',
  hyjybs: 'Futures Trading Competition',
  hyjybsgzsm: 'Futures Trading Competition Details',
  hyspgrphb: 'Futures Trading Competition Leaderboard',
  // 合约大赛规则
  csxz: 'Competition Guidelines: ',
  hybsgz1: "1、Upon registering for the Futures Trading Competition, participants will receive a bonus 100 USDT  (the usage of this bonus is subject to the platform's relevant regulations). Profits made from trading with this bonus will not be counted towards the total profit rate during the competition period.",
  hybsgz2: "2、Users can invite friends to participate in the Futures Trading Competition. For every successfully invited friend who participates, you will receive a 20 USDT bonus in futures trading. The maximum invitation reward is 100 USDT.",
  hybsgz3: '3、This competition is open only to verified users of BiKing Exchange.',
  hybsgz4: '4、At the end of the competition, rankings will be determined based on the total profit rate of users during the competition period.',
  jcfp: 'Prize Pool Distribution: ',
  jcfp1: 'Total Prize Pool: 2,000,000 USDT + 30 exquisite peripherals',
  fpgz: 'Distribution Rule: ',
  fpgzs: '(During bonus disbursement, the Bonus USDT and cash are consistently allocated in a 9:1 ratio.)',
  fpgz1: 'First Place: 800,000 USDT + 5 exquisite peripherals',
  fpgz2: 'Second Place: 500,000 USDT + 5 Exquisite Futures Merchandise',
  fpgz3: 'Third Place: 200,000 USD + 3 Exquisite Futures Merchandise',
  fpgz4: 'Fourth to Twentieth Place: Share 500,000 USDT + 17 Exquisite Futures Merchandise',
  hjyq: 'Prize Requirements',
  hjyq1: '1、Futures contract profit = Final account net value (including unrealized gains and losses) - Initial account net value (including unrealized gains and losses) - Participating futures contract bonus.',
  hjyq2: '2、In the event of participants with the same profit, the one with higher trading volume will be the winner.',
  hjyq3: '3、Winning users must have a net profit greater than 0.',
  // 捐赠
  gyc1: 'This prize pool is open to users in the Futures Trading Competition Zone and Spot Trading Zone. Users can choose to end the competition early and contribute their current trading volume/profit percentage to the charity pool.',
  gyc2: 'The system will contribute to the charity bonus pool at a rate of 0.5 USDT per profit percentage point. The prize pool balance will be displayed on the competition page',
  gyc3: 'For example, if User A has an actual profit percentage of 38%, when this user donates, the system will simultaneously contribute 38 * 0.5 = 19 USDT to the charity pool (charity bonus is in Bonus USDT).',
  gyc4: 'Maximum accumulated amount in the charity pool: 50,000 Bonus USDT in Bonus Trading.',
  gyc5: "When users donate their trading volume, the system will contribute to the charity pool at a rate of 0.5 USDT in charity funds for every 100 USDT in trading volume. For example, if User B's total trading volume is 1000 USDT, the donation to the charity pool will be 0.5 USDT * 10 = 5 USDT (charity bonus is in Bonus USDT).",
  gyc7: 'Donation Guidelines: Each user can participate in charity donations only once. Once a donation is successful, the user is considered to have forfeited their ranking, prize eligibility, and participation in the entire BiKing Trading Competition (Futures Trading Zone users who make a charity donation cannot participate in subsequent Spot Trading Competitions).',
  gyc8: "After the competition ends, the charity prize pool will have three rounds of drawings, with 10 winners in each round sharing the prize money. The prize distribution ratio for the three rounds is 40%, 30%, 30%.",
  gyc9: 'Drawing Time: The random drawings will take place within 7 business days after the trading competition ends. For more details, please consult the official staff.',
  xhjybs: 'Spot Trading Competition',
  xhjybsgzsm: 'Spot Trading Competition Details',
  xhjydsphb: 'Spot Trading Competition Ranking',
  grbmcg: 'Personal registration successful!',
  // 现货实大赛规则
  xhgz1: '1、A competição de negociação à vista inclui todos os pares de negociação à vista na plataforma',
  xhgz2: '2、Participants must have a balance of more than 50 USDT in spot account.',
  xhgz3: "3、After the competition ends, the platform will use the user's total commodity trading volume as the criteria for regional rankings.",
  jjfp: 'Prize Pool',
  zjc: 'Total Prize Pool: 1,000,000 USDT + 20 exquisite peripherals',
  xhdym: '1st Place: 400,000 USDT + 10 peripherals',
  xhdem: '2nd Place: 200,000 USDT + 5 peripherals',
  xhdsm: '3rd Place: 100,000 USDT + 5 peripherals',
  xhdsm1: '4th-20th Place: Share 300,000 USDT',
  mypdnpm: 'Internal Team Leaderboard',
  yqjl1: 'Invitation rewards',
  wdjye: 'My transaction amount: ',
  wdzsyl: 'My total return: ',
  grzjyl: 'Total individual transaction volume: ',
  grzsyl: 'Total personal return: ',
  sqzjye: 'Total transaction amount: ',
  zjye: 'Total transaction volume in the division: ',
  bsyqrs: 'Number of invitees to the competition: ',
  ren: 'person',
  hdmnj: 'Get simulated gold: ',
  hdzj: 'Get bonus: ',
  hyjyxq: 'Contract Details',
  xhjyxq: 'Spot Details',
  hy: 'Contract',
  xh: 'Spot',
  jlsm: 'Reward description ',
  jlsm1: "1.During the competition, users (requiring real-name authentication) can start a group at will. The contract team competition must meet the team size ≥ 5 people; ≤ 200 people; if the group does not reach 5 people within 24 hours after the group is started, the team will be automatically disbanded.",
  jlsm2: '2.Each person can only join one team, no duplicates are allowed, and no one can voluntarily quit the team.',
  tdjye: 'Team transaction volume: ',
  wdjs: 'My role: ',
  dz: 'leader',
  dy: 'member',
  tdzyll: 'Total team profitability: ',
  wdzyll: 'My total profit rate: ',
  tdyjhdjl: 'The team expects to receive: ',
  tdjs1: 'team introduction',
  grxq: 'Personal details',
  tdxq: 'Team details',
  tdjylpm: 'Team trading volume ranking: ',
  tdzsyl: 'Team total profit rate',
  tdnphb: 'Ranking within the team',
  tcsybs: 'Tips: Once the donation is completed, you will exit all competitions',
  zwcjhybs: 'Have not participated in the simulated contract competition yet',
  zwsj: 'No data',
  tdmcbzq: 'Team name format is incorrect',
  tdjjbzq: 'Team profile format is incorrect',
  hdjxz_contract: 'When the perpetual contract trading competition is in full swing, participate in the competition to share the 2,000,000U prize pool and win generous BiKing peripherals',
  hdjxz_spot: 'When the spot trading competition is in full swing, participate in the competition to share the 1,000,000U prize pool and win generous BiKing peripherals',
  hdjs: 'Por favor, aguardem ansiosamente a próxima rodada da competição',
}


// WEBPACK FOOTER //
// ./src/i18n/lang/contest/pt_BR.js